var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Ibox',{attrs:{"title":'Edycja skróconego linku'},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var setLoading = ref.setLoading;
return [_c('Form',{attrs:{"slot":"content"},on:{"loading":setLoading},slot:"content"})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }